<template>
  <div>
    <el-dialog title="学生信息详情" :visible.sync="dialogVisible" @close="$emit('japsetzero');">
      <table
        class="myTable el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        style="width:100%;"
      >
        <tr>
          <td>姓名：{{info.realName}}</td>
          <td>性别：{{info.sex?'男':'女'}}</td>
        </tr>
        <tr>
          <td>添加时间：{{ info.jpInputTime || info.inputTime }}</td>
          <td>营销老师：{{info.marketName}}</td>
        </tr>
        <tr>
          <td>资源状态：{{info.state}}</td>
          <td>学历：{{info.eduBack}}</td>
        </tr>
        <tr>
          <td>地区：{{info.provinceName+info.cityName}}</td>
          <td>学习目的：{{info.purpose}}</td>
        </tr>
        <tr>
          <td>微信：{{info.wechat}}</td>
          <td>QQ：{{info.qq}}</td>
        </tr>
        <tr>
          <td>来源：{{info.origin}}  {{info.recName}}</td>
          <td>日语状态：{{info.japanese}}</td>
        </tr>
        <tr>
          <td>电话：{{info.mobile}}</td>
          <td>学生/家长：{{ info.studentType || '—' }}</td>
        </tr>
        <tr>
          <td>意向课程：{{info.intendedCourse}}</td>
          <td></td>
        </tr>
        <tr>
          <td>跟进情况：{{info.summary}}</td>
          <td></td>
        </tr>
        <tr>
          <td>顾问老师：{{info.adviserName}}</td>
          <td></td>
        </tr>
      </table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false;">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
//学生信息展示
export default {
  props: ["japstuid"],
  data() {
    return {
      info: {}, //用户基本信息
      dialogVisible: false,
      loading: false
    };
  },
  watch: {
    japstuid: function(newVal, oldVal) {
      var _this = this;
      //获取基本信息
      if (newVal > 0) {
        var link = url.getJap("getmodel_base");
        $.get(link, { studentID: newVal }, res => {
          var info = res;
          _this.info = info;
          _this.dialogVisible = true;
        });
      }
    }
  }
};
</script>


<style scoped>
.myTable td {
  text-indent: 10px;
}
.myTable tr td:last-child {
  border-right: 0px;
}
.myTable tr:last-child td {
  border-bottom: 0px;
}
</style>
